import React from 'react';
import { useTranslation } from 'react-i18next';

import {
	WIDGET_TYPE_VIDEO,
	WIDGET_TYPE_IFRAME,
} from '../../../../../../../../constants/scenarioConstant';
import CardData from '../../../../../../utils/CardData';
import { WidgetProps } from '../../../../../widgetOverlay/widgetInteractionItem/WidgetProps';

import Events from './generalSettingsChild/events/Events';

import './Interactivity.scss';

export type InteractivityProps = {
	widgetTemplate: WidgetProps.WidgetTemplate;
	editingScene: { id: string };
	scenes: Array<{ id: string; name: string }>;
	gotoUrlRef: React.Ref<HTMLInputElement> | undefined;
	openNewTabRef: React.Ref<HTMLInputElement> | undefined;
	widgetStartTime: string;
	widgetEndTime: string;
	widgetOverlayRef: any;
	handleWidgetNameChange: () => {};
	handleDestinationSceneChange: () => {};
	handleGotoUrlWidgetChange: () => {};
	handleGotoUrlOpenNewTabChange: () => {};
	handleTimeAttributeChange: (_value: string, _attr: string) => {};
	handleSubmitTimeAttribute: (_value: string, _attr: string) => {};
	handleLocationAttributeChange: (_value: number, _obj: string, _attr?: string) => {};
	handleDeleteWidgetEvent: (_eventType: string) => {};
	handleAddNewEventToWidget: (_eventType: string) => {};
	handleAddActionToEvent: (_actionType: string, _eventType: string) => {};
	handleChangeActionType: (_oldActionType: string, _newActionType: string, _eventType: string) => {};
	handleDeleteAction: (_actionType: string, _eventType: string) => {};
	handleStylingAttributeChange: (_objKey: string | null, _attrKey: string, _value: any) => {};
	handleJumpToTimeMetaDataChange: (_objKey: string) => {};
};

const Interactivity = ({
	widgetTemplate,
	scenes,
	editingScene,
	gotoUrlRef,
	openNewTabRef,
	handleDestinationSceneChange,
	handleGotoUrlWidgetChange,
	handleGotoUrlOpenNewTabChange,
	handleDeleteWidgetEvent,
	handleAddNewEventToWidget,
	handleAddActionToEvent,
	handleChangeActionType,
	handleDeleteAction,
	handleJumpToTimeMetaDataChange,
}: InteractivityProps) => {
	const {
		type,
		events = [],
	} = widgetTemplate;
	const { t: translator } = useTranslation();

	return (
		<CardData title={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_INTERACTIVITY')}>
			{type !== WIDGET_TYPE_VIDEO && type !== WIDGET_TYPE_IFRAME && (
				<Events
					scenes={scenes}
					editingScene={editingScene}
					events={events}
					gotoUrlRef={gotoUrlRef}
					openNewTabRef={openNewTabRef}
					handleDestinationSceneChange={handleDestinationSceneChange}
					handleGotoUrlWidgetChange={handleGotoUrlWidgetChange}
					handleGotoUrlOpenNewTabChange={handleGotoUrlOpenNewTabChange}
					handleDeleteWidgetEvent={handleDeleteWidgetEvent}
					handleAddNewEventToWidget={handleAddNewEventToWidget}
					handleAddActionToEvent={handleAddActionToEvent}
					handleChangeActionType={handleChangeActionType}
					handleDeleteAction={handleDeleteAction}
					handleJumpToTimeMetaDataChange={handleJumpToTimeMetaDataChange}
				/>
			)}
		</CardData>
	);
};

export default Interactivity;
